import { lazy } from 'react';
const Fabricationfinalload = lazy(() => import('./Fabricationfinalload'));

const fabricationfinalloadNewRoutes = [
  {
    path: '/fabricationfinalloadv2',
    component: Fabricationfinalload
  }
];
export default fabricationfinalloadNewRoutes;
